import { PricesRegion } from './price'
import { Override, StrapiID } from './common'
import { Requirements } from './requirements'
import { RemoteImage } from './image'
import { z } from 'zod'

export type PackageVariant = {
  id: StrapiID
  value: string
  lensPrefix: string
  price: PricesRegion
  frames: number
  requires: Requirements
  condition: string | null
  overrides?: Override[]
  image?: RemoteImage
  color?: string | null
}

export const PackageType = {
  sv: 'sv',
  vf: 'vf',
  office: 'office',
} as const

export type PackageType = keyof typeof PackageType

export type PackageConfig = {
  id: StrapiID
  type: PackageType
  name: string
  value: string
  lensPrefix: string
  frames: number
  price: PricesRegion
  color?: string | null
  image?: RemoteImage
  condition?: string | null
  overrides: Partial<Override>[]
  variants: PackageVariant[]
}
